import React from 'react'
import { Icon } from '@iconify/react'
import './style.css'

const StarRating = ({ rating, maxStars = 5, className = '' }) => {
    return (
        <div className={`star-rating ${className}`}>
            {[...Array(maxStars)].map((_, i) => (
                <Icon 
                    key={i} 
                    icon="mdi:star"
                    className={i < rating ? 'star star-filled' : 'star star-empty'} 
                />
            ))}
        </div>
    )
}

export default StarRating

